import React from 'react';
import { Grid, Box, Typography, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  wrapper: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    paddingTop: 20,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: 20,
  },
});

const IMG_WIDTH = 100;

function MainSection({ classes }) {
  return (
    <Box className={classes.wrapper}>
      <Typography variant='h3' style={{ marginTop: 30 }}>
        About Us
      </Typography>
      <Typography variant='body1'>
        Founded in 2021, NexSpec addresses the complexities of content distribution in today's rapidly evolving media supply chain.
      </Typography>
      <Typography variant='body1' style={{ marginTop: 20 }}>
        With over two decades of media distribution technology and services expertise, we serve as a neutral, seamless interface between content creators,
        platform providers, and their vendors. Our mission is to simplify workflows, enhance collaboration, and ensure the efficient delivery of content across
        the digital ecosystem.
      </Typography>
      <Typography variant='body1' style={{ marginTop: 20 }}>
        At NexSpec, we’re dedicated to empowering the media industry with innovative solutions tailored to the needs of a dynamic marketplace.
      </Typography>

      <Typography variant='h3' style={{ marginTop: 30 }}>
        Latest News
      </Typography>
      <Typography variant='subtitle1'>February 5, 2025</Typography>
      <Typography variant='h6'>NexSpec recognized as Prime Preferred Vendor for Technology</Typography>
      <Typography variant='body1'>
        <a
          href='https://www.prnewswire.com/news-releases/nexspec-recognized-as-prime-preferred-vendor-for-technology-302369186.html?tc=eml_cleartime'
          target='_blank'
          rel='noreferrer'
          style={{ color: 'white' }}
        >
          Read More...
        </a>
      </Typography>

      <Typography variant='h3' style={{ marginTop: 30 }}>
        Industry Recognition
      </Typography>
      <Grid container spacing={2} style={{ marginTop: 10 }} alignItems='center'>
        <Grid item>
          <img src={`${process.env.PUBLIC_URL}/images/pvt-prime.png`} alt='prime-preferred-vendor' style={{ width: 130 }} />
        </Grid>
        <Grid item>
          <img src={`${process.env.PUBLIC_URL}/images/partner-dark.png`} alt='partner-dark' style={{ width: IMG_WIDTH }} />
        </Grid>
        <Grid item>
          <img src={`${process.env.PUBLIC_URL}/images/cloud-practitioner.png`} alt='partner-light' style={{ width: IMG_WIDTH }} />
        </Grid>
        <Grid item>
          <img src={`${process.env.PUBLIC_URL}/images/solutions-architect.png`} alt='partner-light' style={{ width: IMG_WIDTH }} />
        </Grid>
        <Grid item>
          <img src={`${process.env.PUBLIC_URL}/images/MovieLabs.jpg`} alt='partner-light' style={{ width: 110 }} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default withStyles(styles, { withTheme: true })(MainSection);
